import layerEvents				from "../utils/layerEvents";
import { 
	Button, 
	Col, 
	Row, 
	Dropdown, 
	Form
}								from "react-bootstrap";
import Select					from "react-select";
import { 
	PencilSimple,
	Lightning, 
	Windmill, 
	Clock, 
	BatteryMedium, 
	Spiral, 
	Ruler, 
	Crosshair, 
	X, 
	Info, 
	Eye, 
	Trash, 
	DotsThreeVertical, 
	Wind, 
	Calculator, 
	Warning, 
	CircleNotch, 
	Plus, 
	Circle, 
	Pencil, 
	Check   
}								from "@phosphor-icons/react";
import {
	format_power, 
	naturalSort
}								from "../utils/functions";
import DataTable				from 'react-data-table-component';
import vindrApi					from "../utils/vindrapi";
import EditNow					from "../components/EditNow";
import DoNowButton				from "../components/DoNowButton";
import ReactDOM					from "react-dom/client";
import LayerTurbine				from "../classes/LayerTurbine";
import LayerEllipses			from "../classes/LayerEllipses";
import JobAep					from "../components/JobAep";
import DialogEditTurbines		from "../layouts/DialogEditTurbines";
import ToolTurbineDetail		from "../classes/ToolTurbineDetail";

class ToolTurbine {

	tabIndex			= null;
	tabIndexDetail		= null;
	highlightedOnList	= [];
	hiddenTurbines		= [];
	allHidden			= false;
	
	turbineTypes		= [];
	turbineHeights		= [];
	modified			= false;
	contextMenu			= null;
	placeholderText		= "DbClick to set name"
	
	constructor(p) {
		this.tc			= p;
		this.newType	= this.tc.scenario.wtgSettings.turbineType ? this.tc.scenario.wtgSettings.turbineType : 'V172';
		this.newHeight	= this.tc.scenario.wtgSettings.hubHeight ? this.tc.scenario.wtgSettings.hubHeight : 150;
		this.canvas		= this.tc.map.getCanvasContainer();
		this.layerData	= LayerTurbine.data;
		this.setupStreamer();
		this.handleAEPRequestDone();
		this.statusRecalculate = !this.tc.scenario.aep.state;
	}
	update(){
		this.modified = false;
		//these vary every time someone changes the dropdown, so we need to update them on every scenario change
		this.turbineTypes = this.tc.scenario.turbine_types ? this.tc.scenario.turbine_types : [];
		this.turbineHeights = this.tc.scenario.hub_heights ? this.tc.scenario.hub_heights : [];
		
		this.newType = this.tc.scenario.wtgSettings.turbineType ? this.tc.scenario.wtgSettings.turbineType : 'V172';
		this.newHeight = this.tc.scenario.wtgSettings.hubHeight ? this.tc.scenario.wtgSettings.hubHeight : 150;
	}

	init(){
			
		this.getTypes().then((res)=>{
			return this.getHeights(this.tc.scenario.wtgSettings.turbineType ? this.tc.scenario.wtgSettings.turbineType : 'V172');
		}).then(()=>{
			this.display();
		})
		this.setEventHandlers();
		this.setAddTurbineListener();
	}
	exit(){
		if(this.tc.serviceBar.current)
			this.tc.serviceBar.current.clear(this.tabIndex);
		this.tabIndex = null;
		this.removeEventHandlers();
		this.closeContextMenu();
		this.closeEditPanel();
	}
	setEventHandlers(){
		
		if(!this.tc)
			return;
		
		this.tc.map.on('contextmenu', this.handleRightClick);
		this.tc.map.on('scenario.updated', this.handleScenarioUpdated);


		this.setInOutListeners();
		this.tc.map.on('mousedown', LayerTurbine.layerId, this.onDown);
		this.tc.map.on('touchstart', LayerTurbine.layerId, this.onTouchStart);		
	}
	removeEventHandlers(){
		if(!this.tc)
			return;
		this.tc.map.off('contextmenu', this.handleRightClick);
		this.unsetInOutListeners();
		this.tc.map.off('mousedown', LayerTurbine.layerId, this.onDown);
		this.tc.map.off('touchstart', LayerTurbine.layerId, this.onTouchStart);
		this.tc.map.off('click', this.addTurbine);
		this.tc.map.off('scenario.updated', this.handleScenarioUpdated);
	}

	setAddTurbineListener(){
		this.setCursor("cursor-add-turbine");
		this.tc.map.on('click', this.addTurbine);
	}
	setInOutListeners(){
		this.tc.map.on('mouseenter', LayerTurbine.layerId, this.onEnter);
		this.tc.map.on('mouseleave', LayerTurbine.layerId, this.onLeave);
	}
	unsetInOutListeners(){
		this.tc.map.off('mouseenter', LayerTurbine.layerId, this.onEnter);
		this.tc.map.off('mouseleave', LayerTurbine.layerId, this.onLeave);
	}
	onUp = (e)=>{
		
		if(e.originalEvent.which != 1)
			return;
		
        const coords = e.lngLat;
		this.setInOutListeners();
        this.remCursor('cursor-grabbing');
		
		if(this.hasMoved && this.currentTurbineId){
			this.tc.updateTurbine(this.currentTurbineId, [coords.lng, coords.lat])
			this.hasMoved = false;
		}
		
		this.currentTurbineId = false;
		this.currentTurbineIdx = false;
		delete this.tc.map.mouseDown;
        // Unbind mouse/touch events
        this.tc.map.off('mousemove', this.onMove);
        this.tc.map.off('touchmove', this.onMove);
		this.resetLayer();
    }

	onDown = (e) => {
		if(e.originalEvent.which != 1)
			return;
		e.preventDefault();
		this.unsetInOutListeners();
		this.getClickedTurbine(e);

		this.setCursor('cursor-grabbing');
		
		//set mousedown var, other events will check this
		this.tc.map.mouseDown = true;
		this.tc.map.on('mousemove', this.onMove);
		this.tc.map.once('mouseup', this.onUp);
	}
    onMove = (e) => {
		
        const coords = e.lngLat;
		this.hasMoved = true;
        // Set a UI indicator for dragging.
        this.canvas.style.cursor = 'grabbing';
		
        // Update the Point feature in `geojson` coordinates
        // and call setData to the source layer `point` on it.
        LayerTurbine.data.features[this.currentTurbineIdx].geometry.coordinates = [coords.lng, coords.lat];
        this.tc.map.getSource(LayerTurbine.sourceId).setData(LayerTurbine.data);
		
		this.handleTurbineDrag(this.currentTurbineId, [coords.lng, coords.lat])
		
    }
	onEnter = (e)=> {
		this.remCursor("cursor-add-turbine").setCursor("cursor-pointer");
		
		const id = e.features[0].id ?? e.features[0].properties.tempid;
		
		this.highlightOnMap(id);
		this.highlightOnList(id);
		
	}
	onLeave = (e)=> {
		this.remCursor("cursor-pointer").setCursor("cursor-add-turbine");
		
		this.deHighlightOnMap();
		this.deHighlightOnList(this.lastHoverId);
	}
	onTouchStart = (e)=>{
		if (e.points.length !== 1) return;

		// Prevent the default map drag behavior.
		e.preventDefault();
		this.getClickedTurbine();
		
		//set mousedown var, other events will check this
		this.tc.map.mouseDown = true;
		
		this.tc.map.on('touchmove', this.onMove);
		this.tc.map.once('touchend', this.onUp);
	}
	getClickedTurbine(e){
		var features = this.tc.map.queryRenderedFeatures(e.point, {layers:[LayerTurbine.layerId]});
		if(features[0]){
			this.currentTurbineId = features[0].id ?? features[0].properties.tempid;
			this.currentTurbineIdx = features[0].properties.idx;
		}
	}
	tName(row, index){
		return row.name;
		
	}
	highlightOnMap = (turbineid) => {
		this.lastHoverId = turbineid;
		
		this.setFeatureProperty(turbineid, "hover", 1);
	}
	deHighlightOnMap = (turbineid) => {
		
		const id = turbineid ?? this.lastHoverId;
		
		this.unsetFeatureProperty(id, "hover");
	}
	setFeatureProperty(id, prop, value){
		
		var data = this.tc.map.getSource(LayerTurbine.sourceId)._options.data;
		const t = data.features.find((f)=>{return (f.id == id || f.properties.tempid == id)});
		t.properties[prop] = value;
		this.tc.map.getSource(LayerTurbine.sourceId).setData(data);
		
	}
	unsetFeatureProperty(id, prop){
		
		var data = this.tc.map.getSource(LayerTurbine.sourceId)._options.data;
		const t = data.features.find((f)=>{return (f.id == id || f.properties.tempid == id)});
		delete t.properties[prop];
		this.tc.map.getSource(LayerTurbine.sourceId).setData(data);
		
	}
	selectOnMap = (turbineid) => {
		this.lastHoverId = turbineid;
		this.setFeatureProperty(turbineid, "selected", 1);
		
	}
	deselectOnMap = (turbineid) => {
		
		const id = turbineid ?? this.lastHoverId;
		
		this.unsetFeatureProperty(id, "selected");
	}
	
	
	highlightOnList = (id) => {
		this.highlightedOnList.push(id);
		
		this.highlightedOnList = [...new Set(this.highlightedOnList)];
		
		this.display();
	}
	deHighlightOnList = (id, silent) => {

		const index = this.highlightedOnList.indexOf(id);
		if (index > -1) { 
			this.highlightedOnList.splice(index, 1); 
		}
		if(!silent)
			this.display();
	}
	
	
	handleRowClick = (row)=>{
		
		
		var a = new ToolTurbineDetail(this, row.turbineid);
	}
	setHideAll(value){
		this.allHidden = value;
		this.display();
	}
	getTypes = ()=>{
			
		const dataRequests = [
			vindrApi.getTurbineTypes(),
		];
			
		return Promise.all(dataRequests)
		.then((res)=>{
			this.turbineTypes = res[0];
		})		
	}
	getHeights = (type)=>{
			
		const dataRequests = [
			vindrApi.getTurbineHeights(type),
		];
			
		return Promise.all(dataRequests)
		.then((res)=>{
			this.turbineHeights = res[0];
		})		
	}
	closeContextMenu() {
		
		if(!this.tc)
			return;
		var a = false;
		if(a = this.tc.map.getContainer().querySelector(".turbineModeContextMenu")){
			a.remove();
		}
		if(!this.tc.map.hasControl(this.tc.draw.draw))
			this.tc.map.addControl(this.tc.draw.draw, 'bottom-left');
		this.contextMenuOpen = false;
	}
	handleScenarioUpdated = () => {
		this.handleAEPRequestDone();
		this.modified = false;
		
	}
	handleRightClick = (e)=>{
		e.originalEvent.preventDefault();
		var features = this.tc.map.queryRenderedFeatures(e.point, {layers:[LayerTurbine.layerId]});
		var id = null;
		if(features.length)
			id = features[0].id ?? features[0].properties.tempid;
		
		var wrp = document.createElement("div");
		wrp.className = "turbineModeContextMenu";
		wrp.style.left = e.point.x+'px';
		wrp.style.top = e.point.y+'px';
		
		this.closeContextMenu();
		
		//remove the draw control because, otherwise disable dragpan doesnt work
		this.tc.map.removeControl(this.tc.draw.draw);
		this.tc.map.dragPan.disable();
		this.contextMenuOpen = true;
		this.tc.map.getContainer().appendChild(wrp);
		
		if(id){
			//right click inside marker
			ReactDOM.createRoot(wrp).render(this.contextMenu(e, id));
		}
		else{
			//right click outside marker
			ReactDOM.createRoot(wrp).render(this.contextMenuAdd(e));
		}
		
		
		
	}
	
	openEditPanel = ()=>{
		
		var wrp = document.createElement("div");
		wrp.className = "turbineEditPanel";
		
		this.closeEditPanel();
		
		this.tc.map.getContainer().appendChild(wrp);
		

		ReactDOM.createRoot(wrp).render(<DialogEditTurbines tc={this.tc} scenario={this.tc.scenario} onClose={this.closeEditPanel} />);
		
	}

	closeEditPanel = () => {
		
		if(!this.tc)
			return;
		var a = false;
		if(a = this.tc.map.getContainer().querySelector(".turbineEditPanel")){
			a.remove();
		}
		
		
	}
	handleTurbineDrag = (id, coords) => {

		const circles = this.tc.draw.circles;
		
		//update circles
	
		//each circle has a dataset for all turbines, find the cicle for the correct turbine in each dataset and regenerate.
		circles.forEach((circle, key)=>{
			
			circle.data.features.forEach((feature, idx)=>{
				
				if(feature.properties.turbineid == id){
					
					var circle_geometry = this.tc.draw.generateCircle(coords, circle.info.radius);
					
					circle.data.features[idx].geometry = circle_geometry.features[0].geometry;
				}
			});
			
			if (circle.info.radius) {
				this.tc.map.getSource('circles_source_'+key).setData(circle.data);
			}
				
		});
		
		const el = new LayerEllipses(this.tc.draw.context);
		
		LayerEllipses.data.features.forEach((feature, idx)=>{

			if(feature.properties.turbineid == id){

				var ellipse_geometry = el.generateEllipse(coords);

				LayerEllipses.data.features[idx].geometry = ellipse_geometry.features[0].geometry;
			}
		});
		//update the data layer of the ellipse
		this.tc.map.getSource(LayerEllipses.sourceId).setData(LayerEllipses.data);
	}
	
	handleHideAllTurbines = () => {
		if(!this.allHidden){
			this.hiddenTurbines = this.tc.scenario.wtgs.map((t)=>{
				this.handleToggleTurbine(t.turbineid, true, true);
				return t.turbineid;
			});
			this.allHidden = true;
		}
		else{
			const copy = this.hiddenTurbines.slice(0);
			copy.forEach((t)=>{this.handleToggleTurbine(t, false, true);});
			this.hiddenTurbines = [];
			this.allHidden = false;
			
		}
		this.display();
	}
	handleToggleTurbine = (turbineid, force, dontRefresh) => {
		
		
		const hidden = document.querySelector("#turb_"+turbineid).classList.toggle("opacity-25", typeof force == "boolean" ? force : undefined);
		if(!hidden){
			const index = this.hiddenTurbines.indexOf(turbineid);
			if (index > -1) {
			  this.hiddenTurbines.splice(index, 1);
			}
			this.allHidden = false;
			this.unsetFeatureProperty(turbineid, "hidden");
		}
		else {
			this.hiddenTurbines.push(turbineid);
			this.setFeatureProperty(turbineid, "hidden", 1);
		}
		
		
		if(!this.hiddenTurbines.length){
			this.allHidden = false;
		}
		if(this.hiddenTurbines.length == this.tc.scenario.wtgs.length){
			this.allHidden = true;
		}
		
		//if(this.hiddenTurbines.length < this.tc.scenario.wtgs.length)
		//	this.setProjFilterCheck(true);
			
		if(!dontRefresh)
			this.display();
		
	}
	setProjFilterCheck(value){
		this.tc.map.getContainer().classList.toggle("hide-turbines", !value);
		document.querySelector("#checkbox_turbines_layer").checked = value;
	}
	handleRemoveTurbine = (e, turbineId) => {
		this.removeTurbine(e, turbineId);
		this.display();
		return true;
	}
	handleBulkDelete = () => {
		if(!this.selected || !this.selected.length)
			return;

		this.selected.forEach((row) => {
			this.removeTurbine(null, row.turbineid);
		});
		
		const {QN} = this.tc.draw.context;
		var count = this.selected.length;
		
		QN.current.show("Deleted "+this.selected.length+" turbines", <Button variant="primary btn-sm" onClick={()=>{this.tc.undo(count)}} >Undo</Button>);
		
		

		this.selected = [];
		this.display();
	}
	handleUpdateName(newName, id){
		this.tc.updateTurbineName(newName, id, true);
		this.display();
	}
	handleEditTurbine(e, turbineid){
		document.getElementById('edit-static-turbine-'+turbineid).dispatchEvent(new MouseEvent("dblclick", {'view': window,'bubbles': true,'cancelable': true}))
	}
	handleEditTurbines = () => {
		
		this.openEditPanel();
		
//		this.getContext().dialogs.setAddCircle({open:true, circle: c, onFinish: ()=>{ 
//				this.display();
//				this.tc.scenario.modified = 1;
//				this.tc.record().add(this.tc.scenario);
//				this.tc.setScenario(this.tc.scenario);
//			}
//		});
//		
		
		
	}
	handleChangeType = (e) => {
		
		this.newType = e.target.value;
		this.newHeight = 0;
		
		this.getHeights(this.newType).then(()=>{
			
			this.display();
		})
		
	}
	handleChangeHeight = (e) => {
		
		this.newHeight = e.target.value;
		
		if(this.newType && this.newHeight)
			this.handleChangeTurbineSettings(this.turbineTypes.find((t)=>{return t.turbine_type == this.newType}), this.newHeight);

		
		this.modified = true;
		this.display();
	}
	handleChangeTurbineSettings = (turbine, height) => {
		
		const projectData = this.tc.draw.context.getters.project;

		this.tc.scenario.wtgSettings.turbineType = turbine.turbine_type
		this.tc.scenario.wtgSettings.hubHeight = parseInt(height)

		//save the current set of types heighs in the scenario
		this.tc.scenario.turbine_types = this.turbineTypes;
		this.tc.scenario.hub_heights = this.turbineHeights;
		
		projectData.short_turbine_radius = turbine.short_turbine_radius;
		projectData.long_turbine_radius = turbine.long_turbine_radius;
		
		this.tc.infoLayers.current.resetSystemLayer("ellipses");
		
		this.tc.scenario.modified = 1;
		this.tc.record().add(this.tc.scenario);
		this.tc.setScenario(this.tc.scenario);

		return true;
	}
	handleDoneAEP = () => {
		
		vindrApi.getScenarioAEP(this.tc.scenario.projectid, this.tc.scenario.scenario_id).then((res)=>{
			var s = {...this.tc.scenario};
			s.aep = res;
			this.tc.setScenario(s);
		});
		
		
	}
	isSelectedOnList = (row)=>{
		return this.highlightedOnList.includes(row.turbineid);
	}
	
	display = ()=>{
		if(this.tc.serviceBar.current)
			this.tabIndex =	this.tc.serviceBar.current.inject(this.render(), this.tabIndex);
	}
	
	contextMenuAdd(map_event){
		return (
			<button className="btn" onClick={(e)=>{ this.closeContextMenu(); this.addTurbine(map_event);}}><Plus size={20} /> Add Turbine</button>
		);
	}
	contextMenu = (map_event, id) => {
		return (
			<>
				<button className="btn" onClick={(e)=>{this.handleEditTurbine(map_event, id); this.closeContextMenu();}}><Pencil size={20} /> Edit name</button>
				<button className="btn" onClick={(e)=>{this.removeTurbine(map_event); this.closeContextMenu();}}><Trash size={20} /> Remove Turbine</button>
			</>
		);
	}
	getContext(){
		return this.tc.draw.context;
	}
	getTurbine(id){
		var a = new ToolTurbineDetail(this, id);
	}
	
	addTurbine = (e) => {
		
		if(this.tc.secondaryHandler)
			return;
		
		var features = this.tc.map.queryRenderedFeatures(e.point, {layers:[LayerTurbine.layerId]});
		if(this.contextMenuOpen){
			this.closeContextMenu();
			return;
		}
		if(features.length){
			this.getTurbine(features[0].id ?? features[0].properties.tempid);
			return;
		}
		

		
		e.originalEvent.stopPropagation();
		var newTurbine = {
			"geometry": {
			  "coordinates": [e.lngLat.lng, e.lngLat.lat],
			  "type": "Point"
			},
			"turbineid": 'temp_'+Math.random().toString(36).substr(2, 9),
			"name": "Turbine " +(this.tc.scenario.wtgs.length+1)
		}
		
		this.tc.scenario.wtgs.push(newTurbine);
		
		//this.draw.drawCircles(this.scenario);

		this.tc.scenario.modified = 1;
		this.tc.setScenario(this.tc.scenario);
		this.tc.record().add(this.tc.scenario);
		
		this.resetLayer();
		let event = {
			scenario:this.tc.scenario, 
			turbine:newTurbine
		};
		this.tc.map.fire("addTurbine", event);
		
	}
	removeTurbine = (e, tId) => { //tId is sent from turbine mode, e is used in eventrs from map
		
		e?.originalEvent?.stopPropagation();
		var	turbineId;
		
		if(tId != null){
			turbineId = tId;
		}
		else {
			var features = this.tc.map.queryRenderedFeatures(e.point, {layers:[LayerTurbine.layerId]});

			if(features.length){
				
				turbineId = features[0].id ?? features[0].properties.tempid;
			}
			
		}	
		if(!turbineId)
			return

		this.tc.updateTurbine(turbineId, null);
		
		this.deHighlightOnList(turbineId, true);
		
		
		let event = {
			scenario:this.scenario, 
			turbine:turbineId
		};
		
		
		this.resetLayer();
		this.tc.map.fire("removeTurbine", event);
	}
	setCursor(cur){
		this.tc.map.getContainer().classList.add(cur);
		return this;
	}
	remCursor(cur){
		this.tc.map.getContainer().classList.remove(cur);
		return this;
	}
	getId(item){
		return item.turbineid ?? item?.properties?.tempid;
	}
	resetLayer = ()=>{
		this.tc.infoLayers.current.resetSystemLayer("turbines");
		this.tc.infoLayers.current.resetSystemLayer("ellipses");
		this.tc.draw.drawCircles(this.tc.scenario);
		
		this.highlightedOnList.forEach((id)=>{
			this.highlightOnMap(id);
		});
		
	}
	handleSelect = (e, row) => {
		
		const id = "turbineid";
		
		if(!this.selected)
			this.selected = [];
		
		
		const idx = this.selected.findIndex((a)=>{return a[id] == row[id]});
		
		if(idx !== -1){
			this.selected.splice(idx, 1);
		}
		else{
			this.selected.push(row);
		}
		this.display();
	}
	
	setupStreamer = () => {
		// create stream
		this.stream = vindrApi.requestCalcProgress(
			'iaep',
			this.tc.scenario.projectid,
			this.tc.scenario.scenario_id
		);

		this.stream.on("processing", data => {
			try {
				const json = JSON.parse(data);
				this.updateState(json);
			} catch {
				this.handleError();
			}
		});

		this.stream.on("completed", data => {
			try {
				const json = JSON.parse(data);
				this.updateState(json);
				this.stream.close();
			} catch {
				this.handleError();
			}
		});

		this.stream.on("error", err => {
			this.stream.close();
			try {
				this.statusText = false;
			} catch {
				this.handleError();
			}
		});

		this.stream.on("message", message => {
			try {
				const json = JSON.parse(message);
				this.updateState(json);
			} catch {
				this.handleError();
			}
		});
	}
	handleError = () => {
		this.statusText = "Error";
		this.statusIcon = <Warning color="red" size={16} />;
		this.display();
	};
	updateState = (json) => {
		
		this.statusText = json.message;

		switch (json.state) {
			case 'processing':
			case 'queued':	
				this.statusRecalculate = false;
				this.statusText = this.formatRemainingTime(json);
				this.statusIcon = <CircleNotch className="spin" size={16} />;
				break;
			case 'completed':
				this.handleDoneAEP();
				this.statusRecalculate = false;
				this.statusIcon = <Check color="green" size={16} />;
				this.stream.close()
				this.hideMsg();
				break;
			case 'error':
				this.hideMsg();
				this.statusRecalculate = true;
				this.stream.close();
				this.statusIcon = <Warning color="red" size={16} />;
				break;
			case 'not_found':
				this.statusText = false;
				this.statusRecalculate = true;
				this.stream.close();
				this.statusIcon = <Warning color="red" size={16} />;
				break;
			default:
				this.statusIcon = false;
		}
		this.display();
	};
	formatRemainingTime = ({ estimated_seconds, estimated_minutes }) => {
		if (estimated_minutes >= 1) {
			const minutes = Math.floor(estimated_minutes);
			const seconds = Math.round((estimated_minutes - minutes) * 60);

			if (minutes === 1 && seconds === 0) {
				return 'About 1 minute remaining';
			}

			if (minutes >= 1 && seconds > 0) {
				return `About ${minutes} minute${minutes > 1 ? 's' : ''} and ${seconds} second${seconds > 1 ? 's' : ''} remaining`;
			}

			return `About ${minutes} minute${minutes > 1 ? 's' : ''} remaining`;
		}
		
		if (estimated_seconds < 60) {
			return estimated_seconds <= 5
				? 'Almost done'
				: `About ${estimated_seconds} seconds remaining`;
		}

		return 'Calculating remaining time...';
	}
	hideMsg = () => {
		setTimeout(()=>{
			this.statusCompleted = true;
			this.statusText = false;
			this.display();
		}, 2000)
	};
	handleCalculateAEP = ()=>{
		
		return vindrApi.newScenarioAEP(this.tc.scenario.projectid,this.tc.scenario.scenario_id).then((resp)=>{
			return resp.id ? {success:true, data:resp}:{success:false}
		});
		
	}
	handleAEPRequestDone = () => {
		this.statusRecalculate = false;
		this.stream.connect();
	}
	render(){
		const error = this.tc.scenario.aep?.state == "error";
		const in_progress = this.tc.scenario.aep?.state == "in_progress";
		const no_aep = !this.tc.scenario.aep?.id;
		
		var wtg = this.tc.scenario.wtgs.filter((t) => t.geometry ? true : false);
		return (
			
			<div className={"project-turbines "}>
				<div className="title">
					Turbines
					<span onClick={(e)=>{this.handleEditTurbines()}} 	className="btn btn-close alt btn-sm float-end"><PencilSimple size={16} /></span>
				</div>
				<div className="scroll">
					
					<div className="content p-0">

						<DataTable
							data={wtg}
							columns={
								[
									{
										name:<Eye onClick={this.handleHideAllTurbines} className={""+(this.allHidden ? 'opacity-25' : '')} size={16} />,
										id:'userid',
										selector: row => row.userid,
										format: (row) =>	(<Eye onClick={(e)=>{this.handleToggleTurbine(row.turbineid, undefined, false)}} id={"turb_"+row.turbineid} data-id={row.turbineid}  className={""+(this.hiddenTurbines.includes(row.turbineid) || this.allHidden ? 'opacity-25' : '')} size={16} />),

										width:'28px !important',
										style: {
											padding: '0',
										}
									},
									{
										name:'',
										selector: this.tName,
										format: (row,index) => ( <label className="checkbox-pad"><Form.Check type="checkbox" id={"check-"+row.turbineid} checked={this.selected && this.selected.some((a)=>a.turbineid == row.turbineid)} onClick={(e)=>{this.handleSelect(e, row);}} /></label>),
										width:"20px",
									},
									{
										id:'name',
										name:'NAME',
										selector: this.tName,
										format: (row,index) => (<EditNow id={'turbine-'+row.turbineid} placeholder={this.placeholderText} value={this.tName(row,index)} onClick={(e)=>{this.handleRowClick(row)}} editable={true} onUpdate={(val)=>{this.handleUpdateName(val, row.turbineid)}} />),
										sortable:true,
										width:"100%",
										sortFunction: (a, b) => naturalSort(a, b, r => r.name),
									},
									{
										name:'AEP',
										selector: row => in_progress ? '' : format_power(row.aep),
										sortable:true,
										right:"true",
										width:"80px !important",
										style: {
										}
									},
									{
										name:'WAKE LOSS',
										selector:(row)=>{return in_progress ? '' : (row.wakeloss ? row.wakeloss +' %' : '')},
										sortable:true,
										right:"true",
										width:"80px !important",
										style: {
										}
									},
									{
										name:'',
										cell: row => (
											<div className="context-menu" data-tag="allowRowEvents">
												<Dropdown className="minimal">
													<Dropdown.Toggle className="p-0 px-1" variant="default">
														<DotsThreeVertical size={16} />
													</Dropdown.Toggle>
													<Dropdown.Menu>
														<Dropdown.Item href="#" onClick={(e)=>{ this.handleEditTurbine(e, row.turbineid);   }}><PencilSimple size={16} /> Edit name</Dropdown.Item>
														{/* <Dropdown.Item href="#" onClick={(e)=>{ this.handleAddCircle(e);   }}><Circle size={16} /> {this.tc.scenario.circles.length ? 'Edit' : 'Add'} circles</Dropdown.Item> */}
														<Dropdown.Item href="#" onClick={(e)=>{ this.handleRemoveTurbine(e, row.turbineid); }} className="text-danger" ><Trash size={16} /> Remove turbine</Dropdown.Item>
													</Dropdown.Menu>
												</Dropdown>
											</div>
										),
										width:"20px !important",
										style: {
										}
									}
								]
							}
							defaultSortFieldId={'name'}
							customStyles={{
								headCells:{
									style: {
										padding:'.5rem .3rem',
										minWidth:'0px !important',
										boxSizing:'content-box',
										fontWeight:'bold'
									}
								},
								cells:{
									style: {
										padding:'.5rem .3rem',
										minWidth:'0px !important',
										boxSizing:'content-box',
										fontSize: 'var(--bs-body-font-size);',
										color:'var(--bs-body-color)',
										'&:last-child':{paddingRight:'1rem'}
									}
								},
								rows:{
									style: {
										minHeight:"0",
									},
									selectedHighlightStyle:{
										backgroundColor:'red'
									}
								}
							}}
							onRowMouseEnter={row=>this.highlightOnMap(this.getId(row))}
							onRowMouseLeave={row=>this.deHighlightOnMap(this.getId(row))}
							onRowClicked={this.handleRowClick }
							selectableRowSelected={r=>this.isSelectedOnList(r)}
							highlightOnHover
							selectableRowsHighlight
							pointerOnHover
							sortIcon={<i className="ri-expand-up-down-line" />}
							noDataComponent={

								<Row className="p-0 py-3 m-0">

									<Col xs="1 pe-0">
										<Info className="text-danger" size={15} />
									</Col>
									<Col xs="11 ps-0">
										<b>Please note:</b> There are currently no turbines placed in this scenario. Please place turbines on the map to calculate the Annual Energy Production (AEP).
									</Col>
								</Row>
							}
						/>
					</div>
				</div>
				{this.selected && !!this.selected.length &&
					<Row className="p-3 batch-action">
						<Col xs="6">
							{this.selected.length} Items selected
						</Col>
						<Col xs="6 text-end">
							<Button variant="primary" onClick={this.handleBulkDelete}>Delete</Button>
						</Col>
					</Row>
				}
				{!!wtg.length && !in_progress &&
				<Row className="p-2 totals">
					<Col xs="2">
						Total
					</Col>
					<Col xs="3">
						{wtg.length} WTG
					</Col>
					<Col xs="3 text-end pe-0">
						{format_power(this.tc.scenario?.aep?.result) ?? 0 }
					</Col>
					<Col xs="3 text-end">
						{this.tc.scenario?.aep?.wakeloss ?? 0} %
					</Col>
				</Row>
				}
				{!!wtg.length && !in_progress &&
				<div className="content  aep">


					<Row className="basic-info mb-2">
						<Col xs="12">
							<Lightning size={16} />
							<span>Total turbine production: </span>

							{format_power(this.tc.scenario?.aep?.result) ?? 0 }
						</Col>
					</Row>
					<Row className="basic-info mb-2">
						<Col xs="12">
							<Wind size={16} />
							<span>Wind mean speed: </span>

							{this.tc.scenario?.aep?.mean_wind_speed ?? 0} m/s
						</Col>
					</Row>
					<Row className="basic-info mb-2">
						<Col xs="12">
							<BatteryMedium size={16} />
							<span>Capacity factor: </span>

							{this.tc.scenario?.aep?.capacity_factor ?? 0} %
						</Col>
					</Row>
					<Row className="basic-info mb-2">
						<Col xs="12">
							<Clock size={16} />
							<span>Full load hours: </span>
							{this.tc.scenario?.aep?.full_load_hours ?? 0} 
						</Col>
					</Row>
				</div>
				}
				<div className="content turbine-settings">

					{(!!this.tc.scenario.modified || this.modified) &&
					<Row className="mb-3">

						<Col xs="1 pe-0">
							<Warning className="text-danger" size={15} />
						</Col>
						<Col xs="11 ps-0">
							<b>Important!</b> Turbine positions, models, or hub heights have changed. Save changes and refresh the page to update AEP.
						</Col>



					</Row>
					}
					
					{!!this.statusRecalculate && 
						<DoNowButton 
							iconIdle={<Calculator  size={16} />}
							btnClassName="btn-land-actions land-book mb-3"
							onClick={()=>{return this.handleCalculateAEP(); }}
							onFinish={this.handleAEPRequestDone}
							text={'Start AEP calculation'}
							textLoading={'Calculating AEP...'}
						/>
					}			
					{!!this.statusText &&		
					<div className="btn btn-land-actions aep-3 mb-3">
						{this.statusIcon}
						{this.statusText}
					</div>
					}
					
					<Row className="mb-3">
						<Form.Group as={Col} md="6">
							<Form.Label>Turbine model</Form.Label>
							<Form.Select className="branded-select light" onChange={this.handleChangeType} value={this.newType}>
								<option value="">Select turbine model</option>
								{this.turbineTypes.map((a, idx) => {
									return <option key={idx} value={a.turbine_type}>{a.turbine_name}</option>
								})}

							</Form.Select>
						</Form.Group>
						<Form.Group as={Col} md="6">
							<Form.Label>HUB Height</Form.Label>

							<Form.Select className="branded-select light" onChange={this.handleChangeHeight}  value={this.newHeight}>
								<option value="0">Select hub height</option>
								{this.turbineHeights.map((a, idx) => {
									return <option key={idx} value={a.hub_height}>{a.hub_height} meters</option>
								})}

							</Form.Select>

						</Form.Group>
					</Row>
				</div>
			</div>	
			
		);
		
	}
}

export default ToolTurbine;